import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getDoubleRoomBoardTaskInfo = createAsyncThunk(
  'DoubleRoomTask/getDoubleRoomBoardTaskInfo',
  async (p: {mid: number; room_id: number}, store: any) => {
    const resp = await http.post('/live/misc/double_room_chat_tasks', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
export const getDoubleRoomTaskInfo = createAsyncThunk(
  'DoubleRoomTask/getDoubleRoomTaskInfo',
  async (p: {room_id: number}, store: any) => {
    const resp = await http.post('/live/misc/double_room_task_detail', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
export const getNewUserList = createAsyncThunk(
  'DoubleRoomTask/getNewUserList',
  async (p: any, store: any) => {
    const resp = await http.post('/live/group/recently_chat_list', {
      ...store.getState().env.deviceinfo,
      ...p,
      share_type: 1,
      type: 0,
    })
    return {data: resp.data, offset: p.offset || 0}
  }
)
export const getRankInfo = createAsyncThunk(
  'DoubleRoomTask/getRankInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/misc/double_room_invite_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const inviteUser = createAsyncThunk(
  'DoubleRoomTask/inviteUser',
  async (p: any, store: any) => {
    const resp = await http.post('/live/group/share_room', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const signupDoubleroomUser = createAsyncThunk(
  'DoubleRoomTask/signupDoubleroomUser',
  async (p: {action: number}, store: any) => {
    const resp = await http.post('/live/misc/sign_up_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
interface task {
  task_id: number
  title: string
  content: string
  step: number
}
interface memberProps {
  member_info: {
    avatar: string
    id: number
    name: string
    zy_id: string
  }
  rank: number
  invite_nums: number
  score: number
}
const initialState: {
  board_info: {
    list: task[]
  }
  new_user_info: {
    offset: number
    more: boolean
    list: {
      id: number
      name: string
      avatar_urls: {aspect_low: {urls: string[]}}
    }[]
  }
  task_info: {
    today_coins: number
    week_coins: number
    list: Array<{
      task_type: number
      title: string
      detail_list: Array<{
        task_type: number
        title: string
        content: string
        status: 0 | 1 // 0未完成, 1 完成
        coins: number
      }>
    }>
  }
  rank_info: {
    list: memberProps[]
    own: memberProps
  }
  recruit: {
    sign_up_status: 0 | 1
  }
} = {
  board_info: {list: []},
  task_info: {
    today_coins: 0,
    week_coins: 0,
    list: [],
  },
  new_user_info: {
    offset: 0,
    more: true,
    list: [],
  },
  rank_info: {
    list: [],
    own: {} as any,
  },
  recruit: {
    sign_up_status: 0,
  },
}
export const DoubleRoomTaskSlice = createSlice({
  name: 'DoubleRoomTask',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDoubleRoomBoardTaskInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {board_info: data})
    })
    builder.addCase(getDoubleRoomTaskInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {task_info: data})
    })
    builder.addCase(getNewUserList.fulfilled, (state, action) => {
      const {
        data: {data},
        offset = 0,
      } = action.payload
      if (offset === 0) {
        Object.assign(state, {
          new_user_info: {...data, offset: data.list?.length || 0},
        })
      } else {
        const newData = {
          ...data,
          list: [...state.new_user_info.list, ...data.list],
          offset: data.list.length + state.new_user_info.offset,
        }
        Object.assign(state, {new_user_info: newData})
      }
    })
    builder.addCase(getRankInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {rank_info: data})
    })
    builder.addCase(signupDoubleroomUser.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {recruit: data})
    })
  },
})
export const DoubleRoomTaskAction = DoubleRoomTaskSlice.actions
export default DoubleRoomTaskSlice.reducer
